/**
 * 261023 유저 "주차QR 가입시키고 알림 테스트하니 깔았는데도 안 깔려 있다고 뜬다(안드로이드)" — 갓 깐 안드로이드 앱의 빈 푸시 토큰.
 *
 * 안드로이드 앱은 첫 화면(Root.vue)이 물을 때 토큰을 5초만 기다렸다가(MainActivity.setPushToken) 빈 값으로 답하고,
 * 늦게 생긴 토큰(FCMMessagingService.onNewToken)은 저장만 할 뿐 웹에 다시 알려 주지 않는다(iOS 는 토큰이 생기면
 * nativeSetDeviceInfo 를 또 부른다 — HybridViewController). 그래서 설치 직후 그 자리에서 가입하면 기기 등록(renew/fcm-token)이
 * 빠져 '알림 시험'이 "받을 휴대폰이 없습니다"였고, 앱을 다시 켜야 등록됐다(운영 10/20~22 안드로이드 가입 4명 중 3명).
 * 앱은 물을 때마다 저장된 토큰을 새로 읽으므로(SharedPreferences) 빈 값이면 5초마다 다시 묻는다 — 앱 업데이트 없이 웹만으로.
 *
 * 다시 물을 때도 콜백은 같은 nativeSetDeviceInfo 다. 안드로이드는 마지막에 받은 콜백 이름 하나로 답해서(registrationKeyCallback),
 * 이름을 따로 쓰면 그 사이 첫 화면이 물은 부팅 답이 이쪽으로 새어 firstRun(첫 실행 권한 창·첫 화면 이동)이 빠진다.
 * 대신 다시 묻기의 답은 한 번 센다(takeReply) — 그 답은 firstRun 을 건너뛴다. 답은 묻기마다 하나씩 온다.
 */
export const PUSH_TOKEN_RETRY_MS = 5000;
export const PUSH_TOKEN_RETRY_MAX = 60; // 5분 — 첫 화면이 다시 물으면(가입·로그인 뒤 '/') 처음부터 다시 센다
// 이만큼 지나도 답이 없으면 놓친 것으로 본다 — 계속 세어 두면 다음 부팅 답의 firstRun 을 먹어 첫 화면('/')이 멈춘다.
export const PUSH_TOKEN_REPLY_MS = 15000;

/**
 * @param ask       앱에 다시 묻는다(nativeGetRegistrationKey('nativeSetDeviceInfo'))
 * @param hasToken  이미 토큰을 받았나(스토어 deviceInfo.pushToken)
 * @param schedule  setTimeout — 시험에서 바꿔 끼운다
 * @param now       Date.now — 시험에서 바꿔 끼운다
 */
export const createPushTokenRetry = ({ ask, hasToken, schedule = (fn, ms) => setTimeout(fn, ms), now = () => Date.now() }) => {
  let left = 0;
  let scheduled = false;
  let askedAt = 0; // 답을 기다리는 다시 묻기를 보낸 시각(0 = 없음). 다음 묻기는 답이 온 뒤에만 잡혀서 한 번에 하나다.
  return {
    /** nativeSetDeviceInfo 맨 앞 — 참이면 다시 묻기의 답이다(부팅 답이 아니니 firstRun 을 건너뛴다). */
    takeReply() {
      if (!askedAt) return false;
      const fresh = now() - askedAt < PUSH_TOKEN_REPLY_MS;
      askedAt = 0;
      return fresh;
    },
    /** 빈 토큰 답을 받았을 때 5초 뒤 다시 묻는다. restart = 부팅 답(첫 화면이 물었다) → 횟수를 처음부터 센다. */
    retryLater(restart) {
      if (restart) left = PUSH_TOKEN_RETRY_MAX;
      if (scheduled || left <= 0) return;
      scheduled = true;
      schedule(() => {
        scheduled = false;
        if (hasToken()) return; // 그 사이 첫 화면이 다시 물어 토큰을 받았다
        left--;
        askedAt = now();
        ask();
      }, PUSH_TOKEN_RETRY_MS);
    }
  };
};
